const DISPLAY_ARTICLE_NUM = 10;

const blogConfig = {
    DISPLAY_ARTICLE_NUM
};
export default blogConfig;